<script setup lang="ts">
export interface IconPauseAll {
  fill?: string;
  width?: number;
  height?: number;
}
const props = withDefaults(defineProps<IconPauseAll>(), { fill: "#A9B7D1", width: 20, height: 20 });
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C4.475 0 0 4.475 0 10s4.475 10 10 10 10-4.475 10-10S15.525 0 10 0zM9 14H7V6h2v8zm4 0h-2V6h2v8z" :fill="props.fill" fill-rule="nonzero" />
  </svg>
</template>
